
import React from 'react';

export const SellerNotificationEmail = ({
  orderDetails,
  sellerName,
  productTitle,
  amount,
  currency,
  shippingMethod,
  buyerInfo
}: {
  orderDetails: {
    id: string;
    created_at: string;
  };
  sellerName: string;
  productTitle: string;
  amount: number;
  currency: string;
  shippingMethod: string;
  buyerInfo: {
    name: string;
    address: string;
    phoneNumber?: string; // Make phoneNumber optional
  };
}) => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>Njoftim Shitje</title>
</head>
<body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
  <div style="text-align: center; margin-bottom: 30px;">
    <h1 style="color: #4F46E5;">Shitje e Re!</h1>
  </div>
  
  <div style="background-color: #f9f9f9; border-radius: 5px; padding: 20px; margin-bottom: 20px;">
    <h2 style="color: #1F2937;">Detajet e Shitjes</h2>
    <p><strong>ID e Porosisë:</strong> ${orderDetails.id}</p>
    <p><strong>Data:</strong> ${new Date(orderDetails.created_at).toLocaleDateString()}</p>
    <p><strong>Produkti:</strong> ${productTitle}</p>
    <p><strong>Çmimi:</strong> ${amount.toFixed(2)} ${currency}</p>
    <p><strong>Metoda e Dërgesës:</strong> ${shippingMethod}</p>
  </div>
  
  <div style="background-color: #f0f7ff; border-radius: 5px; padding: 20px; margin-bottom: 20px;">
    <h2 style="color: #1F2937;">Informacioni i Blerësit</h2>
    <p><strong>Emri:</strong> ${buyerInfo.name}</p>
    <p><strong>Adresa e Dërgesës:</strong> ${buyerInfo.address}</p>
    ${buyerInfo.phoneNumber ? `<p><strong>Nr. Telefonit:</strong> ${buyerInfo.phoneNumber}</p>` : ''}
  </div>

  <div style="margin-top: 30px; text-align: center; color: #666;">
    <p>Faleminderit që përdorni shërbimet tona!</p>
    <p>© ${new Date().getFullYear()} Treguim.org</p>
  </div>
</body>
</html>
  `;
};
